import _ from 'underscore';

export default class UserBuyerSectionMenu {
  constructor($scope) {
    $scope.menu = [
      {
        title: 'Preview',
        action: 'edit_preview',
        pages: [
          'edit_preview'
        ]
      },
      {
        title: 'Overview',
        action: 'overview',
        pages: [
          'overview'
        ]
      },
      {
        title: 'Accounts & Profiles',
        action: 'edit_company_details',
        pages: [
          'edit_company_details',
          'edit_company_contacts'
        ]
      },
      {
        title: 'Trading Infos',
        action: 'edit_trading_general',
        pages: [
          'edit_preferences_categories',
          'edit_preferences_products',
          'edit_preferences_product_groups',
          'edit_preferences_specs',
          'edit_preferences_brands',
          'edit_preferences_volumes',
          'edit_preferences_pricings',
          'edit_preferences_target_pricings',
          'edit_preferences_buyer',
          'edit_preferences_preview',
          'edit_spp_buyer_pricings',
          'edit_spp_special_pricings',
          'edit_spp_special_user_charges',
          'edit_requests_spot',
          'edit_requests_demands',
          'edit_trading_general',
          'edit_trading_order',
          'edit_trading_delivery',
          'edit_trading_payment',
          'edit_trading_special_payment',
          'edit_trading_restrictions'
        ]
      },
      {
        title: 'Opportunities',
        action: 'edit_matched_my',
        pages: [
          'edit_matched_my',
          'edit_matched_suppliers',
          'edit_matched_favorite_offers',
          'edit_matched_favorite_members',
          'edit_matched_inventories'
        ]
      },
      {
        title: 'Advanced Tools',
        action: 'edit_special_faqs',
        pages: [
          'edit_special_faqs',
          'edit_special_roll_messages',
          'edit_alerts',
          'edit_reports',
          'edit_create_spot',
          'edit_create_demand',
          'edit_create_spot_from_offer',
          'edit_create_inventory'
        ]
      },
      {
        title: 'Orders & Offers Requests',
        action: 'edit_orders',
        pages: [
          'edit_orders',
          'edit_arrivals',
          'offer_request_selections',
          'offer_request_reservations',
          'edit_orders_payment',
          'edit_orders_customers'
        ]
      }
    ];

    $scope.init = function() {
      $scope._ = _;
    };

    $scope.init();
  }
}

UserBuyerSectionMenu.$inject = ['$scope'];



// WEBPACK FOOTER //
// ./front/js/admin/controllers/user-buyer-section-menu.ctrl.js